<script>
    import DeviceActionsComponent from "./DeviceActionsComponent.svelte";
</script>

<div>
    <DeviceActionsComponent/>
</div>